"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFlash = exports.flash = exports.toggleNavigation = exports.FlashMessage = exports.FlashMessageType = void 0;
var types = __importStar(require("./constants"));
var FlashMessageType;
(function (FlashMessageType) {
    FlashMessageType["Error"] = "error";
    FlashMessageType["Success"] = "success";
    FlashMessageType["Warning"] = "warning";
    FlashMessageType["Info"] = "info";
})(FlashMessageType || (exports.FlashMessageType = FlashMessageType = {}));
var FlashMessage = /** @class */ (function () {
    function FlashMessage(message, type, options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c;
        this.message = message;
        this.type = type;
        this.duration = (_a = options.duration) !== null && _a !== void 0 ? _a : 5000;
        this.autoClose = (_b = options.autoClose) !== null && _b !== void 0 ? _b : true;
        this.position = (_c = options.position) !== null && _c !== void 0 ? _c : {
            vertical: 'top',
            horizontal: 'center'
        };
    }
    return FlashMessage;
}());
exports.FlashMessage = FlashMessage;
var toggleNavigation = function () { return ({
    type: types.TOGGLE_NAVIGATION,
}); };
exports.toggleNavigation = toggleNavigation;
var flash = function (message, type, options) { return ({
    type: types.SHOW_FLASH_MESSAGE,
    payload: new FlashMessage(message, type, options),
}); };
exports.flash = flash;
var removeFlash = function (message) { return ({
    type: types.REMOVE_FLASH_MESSAGE,
    payload: message,
}); };
exports.removeFlash = removeFlash;
